import { actionGenerator } from "utils";
import { GET_PROVINCES, GET_DISTRICTS, GET_COMMUNES, DELIVERY_INFO } from "./constants";


const actions = {
  GET_PROVINCES: actionGenerator.genActions(GET_PROVINCES),
  GET_DISTRICTS: actionGenerator.genActions(GET_DISTRICTS),
  GET_COMMUNES: actionGenerator.genActions(GET_COMMUNES),
  DELIVERY_INFO: actionGenerator.genActions(DELIVERY_INFO),
};

export default actions;
